import { Injectable, Injector } from "@angular/core";
import { Observable, catchError, of } from "rxjs";
import { SdkBase } from "../utilities/sdk-base/sdk.base";
import { OpenAiSetting } from "../models/open-ai-setting.model";
@Injectable({ providedIn: 'root' })
export class ExternalAppAccountOpenAiSdk extends SdkBase {
    constructor(injector: Injector) {
        super(injector);
    }

    public isLinked(): Observable<boolean | null> {
        return this.makeHttpRequest<boolean>('get', `api2/external-app-accounts/open-ai/linked`)
            .pipe(catchError(() => of(null)));
    }

    public isLinkedByAccountId(accountId: string): Observable<boolean | null> {
        return this.makeHttpRequest<boolean>('get', `api2/external-app-accounts/open-ai/linked/${accountId}`)
            .pipe(catchError(() => of(null)));
    }

    public get(): Observable<OpenAiSetting | null> {
        return this.makeHttpRequest<OpenAiSetting>('get', `api2/external-app-accounts/open-ai`)
            .pipe(catchError(() => of(null)));
    }

    public getByAccountId(accountId: string): Observable<OpenAiSetting | null> {
        return this.makeHttpRequest<OpenAiSetting>('get', `api2/external-app-accounts/open-ai/${accountId}`)
            .pipe(catchError(() => of(null)));
    }

    public postByAccountId(accountId: string, settings: OpenAiSetting): Observable<OpenAiSetting | null> {
        return this.makeHttpRequest<OpenAiSetting>('post', `api2/external-app-accounts/open-ai/${accountId}`, settings)
            .pipe(catchError(() => of(null)));
    }

    public putByAccountId(accountId: string, settings: OpenAiSetting): Observable<OpenAiSetting | null> {
        return this.makeHttpRequest<OpenAiSetting>('put', `api2/external-app-accounts/open-ai/${accountId}`, settings)
            .pipe(catchError(() => of(null)));
    }

    public deleteByAccountId(accountId: string): Observable<boolean | null> {
        return this.makeHttpRequest<boolean>('delete', `api2/external-app-accounts/open-ai/${accountId}`)
            .pipe(catchError(() => of(null)));
    }
}